export const UK_REGULATION_TYPE = 255;
